import LineworkList from "../../components/Linework/List";

const LineworkListPage = () => {
  return <LineworkList />;
};

export default LineworkListPage;
